module.exports = __webpack_public_path__ + "img/alex.ec66af0b.jpg";